import styled from 'styled-components';
export const PasswordFieldContainer = styled.div`
  display: flex;
  flex-direction: column;

  opacity: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled ? 0.5 : 1;
}};
  width: 100%;
`;
export const Label = styled.label`
  ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fonts.labelMD;
}}
  color: #FFF;
  margin-bottom: 12px;
`;
export const InputContainer = styled.div`
  background-color: ${_ref3 => {
  let {
    theme,
    pressed
  } = _ref3;
  return pressed ? theme?.colors?.secondaryL1 : theme?.colors?.secondary;
}};
  border: 1px solid
    ${_ref4 => {
  let {
    theme,
    isFocused,
    error
  } = _ref4;
  if (error) return theme?.colors?.error;
  return isFocused ? theme?.colors?.secondaryL3 : 'transparent';
}};
  border-radius: 10px;
  height: ${_ref5 => {
  let {
    size
  } = _ref5;
  return size === 'md' ? '48px' : '64px';
}};
  padding: ${_ref6 => {
  let {
    size
  } = _ref6;
  return size === 'md' ? '14px' : '22px 14px';
}};

  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Input = styled.input`
  ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.fonts.infoLG;
}}
  color: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme?.colors?.neutralL5;
}};
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;

  &::placeholder {
    color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme?.colors?.secondaryL2;
}};
  }
`;
export const IconBox = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
export const HelpMessage = styled.div`
  ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.fonts.textMD;
}}
  margin: 0;
  margin-top: 4px;
  color: ${_ref11 => {
  let {
    theme,
    error
  } = _ref11;
  return error ? theme?.colors?.error : theme?.colors?.neutralL5;
}};
  height: 18px;
`;